import React, { useState, useEffect, useRef } from "react";
import axiosInstance from '../axiosInstance';
import { FaSearch, FaPen, FaPlus, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import * as general from '../libs/general';
import Paging from '../components/Paging';
import AdLayout from '../components/AdLayout';
import DataTable from '../components/ui/DataTable';
import { fetchPartnerMenuPermissions } from "../libs/customerCreatePermission";

const Contacts = () => {
  const [pageData, setPageData] = useState({ content: [] });
  const [message, setMessage] = useState("");
  const hasRun = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [partnerFeaturePerm, setPartnerFeaturePerm] = useState({
    loaded: false,
    canView: false,
    canCreate: false,
    canEdit: false,
    canDelete: false,
  });

  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();


  useEffect(() => {
    searchContacts();
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchPartnerMenuPermissions(axiosInstance);
      if (!cancelled) {
        setPartnerFeaturePerm({
          loaded: true,
          canView: Boolean(p.canView),
          canCreate: p.canCreate,
          canEdit: p.canEdit,
          canDelete: Boolean(p.canDelete),
        });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchContacts({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchContacts({ page: page - 1 });
  };
  const handleSearchChange = (e) => {
    var searchValue = e.target.value;
    searchContacts({ page: 0, keyword: searchValue });
    setSearchQuery(e.target.value);
  };

  const searchContacts = async (filter) => {
    if (window.calling) return;
    window.calling = true;
    setIsLoading(true);
    setMessage('');
    var params = general.getSession('search_contacts');

    var formData = general.getFormData('.form_filter');
    Object.assign(params, formData);

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('search_contacts');
      Object.assign(params, oldParams);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('search_contacts', params);
    window.initializeFilterValue(params);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    var response = {};
    try {
      response = await axiosInstance.get('/api/contacts/searchContacts', { params: filteredParams });
      setPageData(response.data);
    } catch (error) {
      setPageData({ content: [] });
      setMessage(error.message);
      console.error(error);
    } finally {
      window.calling = false;
    }
    setIsLoading(false);
  };

  const handleDeleteContact = (item) => {
    if (!partnerFeaturePerm.canDelete || !item?.id) return;
    const label = String(item.code || item.name || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    general.openConfirm(async () => {
      try {
        const response = await axiosInstance.post(`/api/contacts/deleteContact/${item.id}`, {});
        if (!response.data?.success) {
          toast.error(response.data?.message || "Xóa đối tác thất bại");
          return;
        }
        toast.success(response.data.message || "Đã xóa đối tác");
        searchContacts();
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
      }
    }, `Bạn có chắc chắn muốn xóa đối tác ${label}?`);
  };

  return (
    <div>
      <AdLayout>
        <div className="table-responsive web-table customer-management-page">
          <div className="container-fluid">
            <div className="row bg-dark align-items-center">
              <div className="col-12 col-md-7 order-3 order-md-1 py-1 d-flex align-items-center">
                <div className="flex-start gap-2">
                  {partnerFeaturePerm.canCreate && (
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      onClick={() => navigate(`/contact`)}
                      title="Đối tác mới"
                    >
                      <FaPlus /> Thêm mới
                    </button>
                  )}
                </div>
              </div>
              <div className="col-7 col-md-2 py-1 fw-bold text-white text-uppercase d-flex align-items-center justify-content-star order-1 order-md-2">
                Quản lý đối tác
              </div>
              <div className="col-5 col-md-3 py-1 order-2 order-md-3 d-flex justify-content-end align-items-center">
                <form className="form_filter mb-0 w-auto">
                  <div className="input-group search-block flex-nowrap">
                    <input name="keyword"
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Tìm kiếm..."
                      value={searchQuery}
                      onChange={(e) => handleSearchChange(e)}  // Ensure `e` is passed to the function
                    />
                    <button className="btn btn-light btn-sm" type="button" title="Tìm kiếm..." onClick={(event) => searchContacts({ page: 0 })}>
                      <FaSearch />
                    </button>
                  </div>
                </form>
              </div>
            </div>


          </div>

          <section>
            <DataTable maxHeight="calc(100vh - 160px)" className="table-normal" data-loading={isLoading}>
              <table className="table table-striped table-bordered">
                <thead className="table-primary">
                  <tr>
                    <th width="30px" className="sticky">STT</th>
                    <th>Mã đối tác</th>
                    <th>Tên đối tác</th>
                    <th>Địa chỉ</th>
                    <th>
                      <span>Lines</span>
                    </th>
                    <th width="200px"><span>Ngày</span></th>
                    <th width="100px">Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  {pageData.page && pageData.page.content && pageData.page.content.map((item, index) => (
                    <tr key={item.id}>
                      <td className="sticky">{(pageData.page.number * pageData.page.size) + index + 1}</td>
                      <td className="text-start">
                        {partnerFeaturePerm.canView || partnerFeaturePerm.canEdit ? (
                          <button
                            type="button"
                            className="btn btn-link p-0 text-start text-decoration-none"
                            style={{ color: "#485766" }}
                            onClick={() => navigate(`/contact/${item.id}`)}
                            title="Xem chi tiết đối tác"
                          >
                            {item.code}
                          </button>
                        ) : (
                          <span>{item.code}</span>
                        )}
                      </td>
                      <td className="text-start">
                        {partnerFeaturePerm.canView || partnerFeaturePerm.canEdit ? (
                          <button
                            type="button"
                            className="btn btn-link p-0 text-start text-decoration-none"
                            style={{ color: "#485766" }}
                            onClick={() => navigate(`/contact/${item.id}`)}
                            title="Xem chi tiết đối tác"
                          >
                            {item.name}
                          </button>
                        ) : (
                          <span>{item.name}</span>
                        )}
                      </td>
                      <td className="text-start">{item.address}</td>
                      <td className="text-start" dangerouslySetInnerHTML={{ __html: general.formatSelect3(item.lines) }}></td>
                      <td><span title={general.formatDateTime(item.createdAt)}></span> {general.formatDate(item.createdAt)}</td>

                      <td className="text-center align-middle">
                        <div>
                          {partnerFeaturePerm.canEdit && (
                            <FaPen className="text-primary me-2" role="button" tabIndex={0} onClick={() => navigate(`/contact/${item.id}`)} onKeyDown={(e) => e.key === "Enter" && navigate(`/contact/${item.id}`)} size={15} title="Cập nhật" />
                          )}
                          {partnerFeaturePerm.canDelete && (
                            <FaTrash className="text-danger" role="button" tabIndex={0} onClick={() => handleDeleteContact(item)} onKeyDown={(e) => e.key === "Enter" && handleDeleteContact(item)} size={15} title="Xóa" />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}

                  {message === '' && pageData.page && pageData.page.content.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center">Không tìm thấy dữ liệu</td>
                    </tr>
                  )}
                  {message !== '' && (
                    <tr>
                      <td colSpan="7" className="text-center">{message}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </DataTable>
          </section>
          <div className="mt-2 d-flex justify-content-end align-items-center">
            <Paging
              pageData={pageData}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleChangeItemsPerPage}
            />
          </div>
        </div>
      </AdLayout>
    </div>
  );
}
export default Contacts;